module.exports = __webpack_public_path__ + "static/media/mevuelo.0ace62e7.svg";